import React from 'react';

export type ToolbarButtonProps = {
  // eslint-disable-next-line react/require-default-props
  isActive?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ToolbarButton = ({ isActive = false, ...rest }: ToolbarButtonProps) => (
  <button
    type="button"
    className={`cursor-pointer rounded border-0 px-0 pb-0 pt-1 ${isActive ? 'bg-kat-eastern text-white' : 'bg-transparent hover:bg-kat-zircon'}`}
    aria-pressed={isActive}
    {...rest}
  />
);

export default ToolbarButton;
